// extracted by mini-css-extract-plugin
export default {"button":"DownloadQRCodeButton_button__Uk8bS"};